module.exports = __webpack_public_path__ + "static/the-soul-of-a-new-machine-dbf10a607449a549e581b9d7a3144b0c.jpg";